export default __webpack_public_path__ + "5bdd47f597457b38bcf054e77d9aebdd.png";